import { useState, useEffect, useCallback, useRef } from "react";
import axiosInstance from "../../api/axiosInstance";

const TOAST_DURATION = 4000;

const kycApi = {
  get: (vendorProfileId) =>
    axiosInstance.get(`/api/superadmin/vendors/${vendorProfileId}/kyc/`),

  create: (vendorProfileId, body) =>
    axiosInstance.post(`/api/superadmin/vendors/${vendorProfileId}/kyc/`, body),

  patch: (vendorProfileId, id, body) =>
    axiosInstance.patch(`/api/superadmin/vendors/${vendorProfileId}/kyc/${id}/`, body),

  delete: (vendorProfileId, id) =>
    axiosInstance.delete(`/api/superadmin/vendors/${vendorProfileId}/kyc/${id}/`),
};

const CloseIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const LoaderIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    style={{ animation: "kyc-spin 0.8s linear infinite" }}>
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);
const ShieldIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const ShieldCheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);
const FileTextIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);
const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const RefreshIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const BuildingIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);
const MapPinIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const CalendarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const AlertTriangleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

let _kycToastSetter = null;
const toast = {
  _push: (item) => {
    const id = Date.now() + Math.random();
    _kycToastSetter?.((p) => [...p, { id, ...item }]);
    return id;
  },
  success: (title, msg) => toast._push({ type: "success", title, msg }),
  error:   (title, msg) => toast._push({ type: "error",   title, msg }),
  info:    (title, msg) => toast._push({ type: "info",    title, msg }),
  loading: (title)      => toast._push({ type: "loading", title, persistent: true }),
  dismiss: (id)         => _kycToastSetter?.((p) => p.filter((t) => t.id !== id)),
};
const TOAST_META = {
  success: { bar: "#16a34a", icon: "✓" },
  error:   { bar: "#dc2626", icon: "✕" },
  info:    { bar: "#1d4ed8", icon: "i" },
  loading: { bar: "#94a3b8", icon: null },
};
const ToastItem = ({ t, onDismiss }) => {
  const meta = TOAST_META[t.type];
  const [progress, setProgress] = useState(100);
  const [exiting, setExiting] = useState(false);
  const rafRef = useRef(null);
  const startTs = useRef(Date.now());
  const dismiss = useCallback(() => {
    setExiting(true);
    setTimeout(() => onDismiss(t.id), 280);
  }, [t.id, onDismiss]);
  useEffect(() => {
    if (t.persistent) return;
    const tick = () => {
      const pct = Math.max(0, 100 - ((Date.now() - startTs.current) / TOAST_DURATION) * 100);
      setProgress(pct);
      if (pct > 0) rafRef.current = requestAnimationFrame(tick);
      else dismiss();
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [t.persistent, dismiss]);
  return (
    <div style={{ position: "relative", overflow: "hidden", background: "#fff", borderRadius: 10, borderLeft: `4px solid ${meta.bar}`, boxShadow: "0 4px 20px rgba(0,0,0,0.10), 0 0 0 1px rgba(0,0,0,0.06)", minWidth: 300, maxWidth: 360, animation: exiting ? "kyc-alOut 0.28s ease forwards" : "kyc-alIn 0.28s cubic-bezier(0.34,1.56,0.64,1) forwards" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "13px 14px 14px" }}>
        <div style={{ flexShrink: 0, width: 24, height: 24, borderRadius: "50%", background: `${meta.bar}18`, display: "flex", alignItems: "center", justifyContent: "center", marginTop: 1 }}>
          {t.type === "loading" ? (
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" style={{ animation: "kyc-spin 0.85s linear infinite" }}>
              <circle cx="6.5" cy="6.5" r="5" stroke={meta.bar} strokeWidth="2" strokeDasharray="8 20" strokeLinecap="round" />
            </svg>
          ) : <span style={{ fontSize: 11, fontWeight: 800, color: meta.bar, lineHeight: 1 }}>{meta.icon}</span>}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: 13.5, fontWeight: 650, color: "#0f172a", lineHeight: 1.35 }}>{t.title}</p>
          {t.msg && <p style={{ margin: "3px 0 0", fontSize: 12.5, color: "#64748b", lineHeight: 1.5 }}>{t.msg}</p>}
        </div>
        <button onClick={dismiss} style={{ background: "none", border: "none", cursor: "pointer", color: "#cbd5e1", padding: "2px", flexShrink: 0, display: "flex", borderRadius: 4 }}
          onMouseEnter={(e) => e.currentTarget.style.color = "#94a3b8"}
          onMouseLeave={(e) => e.currentTarget.style.color = "#cbd5e1"}>
          <CloseIcon />
        </button>
      </div>
      {!t.persistent && (
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: "#f1f5f9" }}>
          <div style={{ height: "100%", width: `${progress}%`, background: meta.bar, transition: "width 0.1s linear", borderRadius: "0 2px 0 0" }} />
        </div>
      )}
    </div>
  );
};
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  _kycToastSetter = setToasts;
  const dismiss = useCallback((id) => setToasts((p) => p.filter((t) => t.id !== id)), []);
  if (!toasts.length) return null;
  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-end" }}>
      {toasts.map((t) => <ToastItem key={t.id} t={t} onDismiss={dismiss} />)}
    </div>
  );
};

const KYC_STATUS_CONFIG = {
  verified:    { bg: "#dcfce7", color: "#16a34a", dot: "#22c55e", label: "Verified"    },
  pending:     { bg: "#fef3c7", color: "#d97706", dot: "#f59e0b", label: "Pending"     },
  failed:      { bg: "#fee2e2", color: "#dc2626", dot: "#f43f5e", label: "Failed"      },
  not_started: { bg: "#f1f5f9", color: "#64748b", dot: "#94a3b8", label: "Not Started" },
  rejected:    { bg: "#fff1f2", color: "#e11d48", dot: "#f43f5e", label: "Rejected"    },
};
const StatusBadge = ({ status }) => {
  const cfg = KYC_STATUS_CONFIG[status] || KYC_STATUS_CONFIG.not_started;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: cfg.bg, color: cfg.color }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot, display: "inline-block" }} />
      {cfg.label}
    </span>
  );
};

const InfoRow = ({ icon, label, value, mono, badge }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "7px 0", borderBottom: "1px solid #f8fafc" }}>
    <span style={{ color: "#94a3b8", display: "flex", flexShrink: 0, marginTop: 1 }}>{icon}</span>
    <span style={{ fontSize: 12.5, color: "#94a3b8", fontWeight: 550, minWidth: 160, flexShrink: 0 }}>{label}</span>
    {badge ? (
      badge
    ) : (
      <span style={{ fontSize: 13, color: mono ? "#1e40af" : "#1e293b", fontWeight: mono ? 700 : 500, fontFamily: mono ? "monospace" : "inherit", flex: 1, wordBreak: "break-word" }}>
        {value ?? <span style={{ color: "#cbd5e1" }}>—</span>}
      </span>
    )}
  </div>
);

const SectionTitle = ({ icon, title, subtitle }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "20px 0 10px", paddingBottom: 6, borderBottom: "1.5px solid #f1f5f9" }}>
    <span style={{ color: "#6366f1", display: "flex" }}>{icon}</span>
    <h4 style={{ margin: 0, fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>{title}</h4>
    {subtitle && <span style={{ fontSize: 11.5, background: "#f1f5f9", color: "#64748b", padding: "1px 7px", borderRadius: 20, fontWeight: 600 }}>{subtitle}</span>}
  </div>
);

const SkeletonBlock = ({ w, h = 14 }) => (
  <div style={{ height: h, width: w, borderRadius: 6, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "kyc-shimmer 1.4s infinite" }} />
);
const KYCSkeleton = () => (
  <div style={{ display: "flex", flexDirection: "column", gap: 16, padding: 24 }}>
    <SkeletonBlock w="60%" h={20} />
    <SkeletonBlock w="40%" />
    <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
      {[1, 2].map(i => <div key={i} style={{ flex: 1, padding: 16, borderRadius: 10, border: "1px solid #e2e8f0", display: "flex", flexDirection: "column", gap: 10 }}>
        <SkeletonBlock w="50%" h={16} />
        {[1, 2, 3, 4].map(j => <SkeletonBlock key={j} w={`${60 + j * 8}%`} />)}
      </div>)}
    </div>
  </div>
);

const ConfirmDeleteModal = ({ onConfirm, onCancel, loading }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: 20 }}
    onClick={onCancel}>
    <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 400, padding: 28, boxShadow: "0 24px 64px rgba(0,0,0,0.20)", animation: "kyc-fadeUp 0.2s ease" }}
      onClick={e => e.stopPropagation()}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, textAlign: "center" }}>
        <div style={{ width: 52, height: 52, borderRadius: "50%", background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div>
          <h3 style={{ margin: "0 0 6px", fontSize: 17, fontWeight: 700, color: "#0f172a" }}>Delete KYC Record?</h3>
          <p style={{ margin: 0, fontSize: 13.5, color: "#64748b", lineHeight: 1.6 }}>
            This will permanently remove all KYC data for this vendor. This action cannot be undone.
          </p>
        </div>
        <div style={{ display: "flex", gap: 10, marginTop: 8, width: "100%" }}>
          <button onClick={onCancel} disabled={loading}
            style={{ flex: 1, padding: "10px 0", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151" }}>
            Cancel
          </button>
          <button onClick={onConfirm} disabled={loading}
            style={{ flex: 1, padding: "10px 0", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", background: loading ? "#fca5a5" : "#dc2626", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
            {loading ? <><LoaderIcon /> Deleting…</> : <><TrashIcon /> Delete</>}
          </button>
        </div>
      </div>
    </div>
  </div>
);

const KYC_STATUS_OPTIONS = ["not_started", "pending", "verified", "failed"];

const KYCFormModal = ({ mode, initialData, onClose, onSuccess, vendorProfileId }) => {
  const isEdit = mode === "edit";
  const [form, setForm] = useState({
    gstin:            initialData?.gstin            ?? "",
    gst_status:       initialData?.gst_status       ?? "not_started",
    gst_attempts:     initialData?.gst_attempts     ?? 0,
    gst_locked:       initialData?.gst_locked       ?? false,
    gst_verified_name: initialData?.gst_verified_name ?? "",
    pan:              initialData?.pan              ?? "",
    pan_status:       initialData?.pan_status       ?? "not_started",
    pan_attempts:     initialData?.pan_attempts     ?? 0,
    pan_locked:       initialData?.pan_locked       ?? false,
    pan_verified_name: initialData?.pan_verified_name ?? "",
    ...(isEdit ? {
      gst_city:    initialData?.gst_city    ?? "",
      gst_state:   initialData?.gst_state   ?? "",
      gst_country: initialData?.gst_country ?? "",
      gst_pincode: initialData?.gst_pincode ?? "",
    } : {}),
  });
  const [saving, setSaving]   = useState(false);
  const [errors, setErrors]   = useState({});

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = ""; document.removeEventListener("keydown", onKey); };
  }, [onClose]);

  const validate = () => {
    const e = {};
    if (!form.gstin.trim())       e.gstin = "GSTIN is required.";
    else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]Z[0-9A-Z]$/.test(form.gstin.trim()))
      e.gstin = "Invalid GSTIN format (e.g. 29ABCDE1234F1Z5).";
    if (!form.pan.trim())         e.pan = "PAN is required.";
    else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(form.pan.trim()))
      e.pan = "Invalid PAN format (e.g. ABCDE1234F).";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setSaving(true);
    const loadId = toast.loading(isEdit ? "Updating KYC…" : "Creating KYC…");
    try {
      const { data } = isEdit
        ? await kycApi.patch(vendorProfileId, initialData.id, form)
        : await kycApi.create(vendorProfileId, form);

      if (data?.status >= 400) {
        const detail = data?.data?.detail || data?.data?.message || "Save failed";
        if (!isEdit && data?.status === 400 && detail.toLowerCase().includes("already exists")) {
          toast.dismiss(loadId);
          toast.info("Already Exists", "KYC record exists. Use Edit to update it.");
          onClose();
          return;
        }
        const fieldErrors = {};
        Object.entries(data?.data || {}).forEach(([k, v]) => {
          if (k !== "detail" && k !== "message") fieldErrors[k] = Array.isArray(v) ? v[0] : v;
        });
        if (Object.keys(fieldErrors).length > 0) setErrors(fieldErrors);
        throw new Error(detail);
      }

      toast.dismiss(loadId);
      toast.success(isEdit ? "KYC Updated" : "KYC Created", isEdit ? "KYC record updated successfully." : "KYC record created successfully.");
      onSuccess(data?.data ?? data);
      onClose();
    } catch (err) {
      toast.dismiss(loadId);
      if (!err.message?.toLowerCase().includes("already exists"))
        toast.error(isEdit ? "Update Failed" : "Create Failed", err.message || "An unexpected error occurred.");
    } finally {
      setSaving(false);
    }
  };

  const Field = ({ label, name, placeholder, mono, readOnly, hint }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", letterSpacing: "0.03em" }}>{label}</label>
      <input
        value={form[name] ?? ""}
        onChange={e => { setForm(p => ({ ...p, [name]: e.target.value })); if (errors[name]) setErrors(p => ({ ...p, [name]: null })); }}
        placeholder={placeholder}
        readOnly={readOnly}
        style={{ padding: "9px 12px", border: `1px solid ${errors[name] ? "#fca5a5" : "#e2e8f0"}`, borderRadius: 8, fontSize: 13, background: readOnly ? "#f8fafc" : "#fff", color: mono ? "#1e40af" : "#1e293b", fontFamily: mono ? "monospace" : "inherit", outline: "none", transition: "border-color 0.15s" }}
        onFocus={e => { if (!readOnly) e.target.style.borderColor = errors[name] ? "#f87171" : "#3b82f6"; }}
        onBlur={e  => { e.target.style.borderColor = errors[name] ? "#fca5a5" : "#e2e8f0"; }}
      />
      {errors[name] && <span style={{ fontSize: 11.5, color: "#dc2626", display: "flex", alignItems: "center", gap: 4 }}><AlertTriangleIcon />{errors[name]}</span>}
      {hint && !errors[name] && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>{hint}</span>}
    </div>
  );

  const SelectField = ({ label, name }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: "#475569", letterSpacing: "0.03em" }}>{label}</label>
      <div style={{ position: "relative" }}>
        <select
          value={form[name]}
          onChange={e => setForm(p => ({ ...p, [name]: e.target.value }))}
          style={{ width: "100%", padding: "9px 32px 9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, background: "#fff", color: "#1e293b", outline: "none", appearance: "none", cursor: "pointer" }}>
          {KYC_STATUS_OPTIONS.map(s => (
            <option key={s} value={s}>{KYC_STATUS_CONFIG[s]?.label || s}</option>
          ))}
        </select>
        <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}><ChevronDownIcon /></span>
      </div>
    </div>
  );

  const ToggleField = ({ label, name }) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
      <span style={{ fontSize: 13, fontWeight: 550, color: "#374151", display: "flex", alignItems: "center", gap: 6 }}><LockIcon />{label}</span>
      <button
        type="button"
        onClick={() => setForm(p => ({ ...p, [name]: !p[name] }))}
        style={{ width: 44, height: 24, borderRadius: 12, border: "none", cursor: "pointer", background: form[name] ? "#3b82f6" : "#e2e8f0", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
        <span style={{ position: "absolute", top: 2, left: form[name] ? 22 : 2, width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.15)", transition: "left 0.2s" }} />
      </button>
    </div>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 640, boxShadow: "0 24px 64px rgba(0,0,0,0.20)", animation: "kyc-fadeUp 0.2s ease", display: "flex", flexDirection: "column", maxHeight: "90vh" }}
        onClick={e => e.stopPropagation()}>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f1f5f9", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: isEdit ? "linear-gradient(135deg,#f59e0b,#d97706)" : "linear-gradient(135deg,#6366f1,#3b82f6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isEdit ? <EditIcon /> : <ShieldIcon />}
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#0f172a" }}>{isEdit ? "Edit KYC Record" : "Create KYC Record"}</h2>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: "#94a3b8" }}>{isEdit ? "Update GST and PAN verification details" : "Initialize KYC for this vendor"}</p>
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 6, borderRadius: 6 }}
            onMouseEnter={e => e.currentTarget.style.color = "#64748b"}
            onMouseLeave={e => e.currentTarget.style.color = "#94a3b8"}>
            <CloseIcon />
          </button>
        </div>

        <div style={{ overflowY: "auto", padding: "20px 24px", flex: 1, display: "flex", flexDirection: "column", gap: 20 }}>

          <div style={{ background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0", padding: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 14 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <ShieldCheckIcon />
              </div>
              <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>GST Information</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="GSTIN *" name="gstin" placeholder="e.g. 29ABCDE1234F1Z5" mono hint="15-character GST Identification Number" />
              </div>
              <SelectField label="GST Status" name="gst_status" />
              <Field label="GST Attempts" name="gst_attempts" placeholder="0" />
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="GST Verified Name" name="gst_verified_name" placeholder="Legal name as per GST" />
              </div>
              {isEdit && (
                <>
                  <Field label="GST City" name="gst_city" placeholder="City" />
                  <Field label="GST Pincode" name="gst_pincode" placeholder="Pincode" />
                  <Field label="GST State" name="gst_state" placeholder="State" />
                  <Field label="GST Country" name="gst_country" placeholder="Country" />
                </>
              )}
              <div style={{ gridColumn: "1/-1" }}>
                <ToggleField label="GST Locked" name="gst_locked" />
              </div>
            </div>
          </div>

          <div style={{ background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0", padding: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 14 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FileTextIcon />
              </div>
              <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>PAN Information</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="PAN *" name="pan" placeholder="e.g. ABCDE1234F" mono hint="10-character Permanent Account Number" />
              </div>
              <SelectField label="PAN Status" name="pan_status" />
              <Field label="PAN Attempts" name="pan_attempts" placeholder="0" />
              <div style={{ gridColumn: "1/-1" }}>
                <Field label="PAN Verified Name" name="pan_verified_name" placeholder="Name as per PAN" />
              </div>
              <div style={{ gridColumn: "1/-1" }}>
                <ToggleField label="PAN Locked" name="pan_locked" />
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "16px 24px", borderTop: "1px solid #f1f5f9", flexShrink: 0 }}>
          <button onClick={onClose} disabled={saving}
            style={{ padding: "9px 20px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151" }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={saving}
            style={{ padding: "9px 22px", border: "none", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", background: saving ? "#93c5fd" : (isEdit ? "#f59e0b" : "#3b82f6"), color: "#fff", display: "flex", alignItems: "center", gap: 7 }}>
            {saving ? <><LoaderIcon /> Saving…</> : (isEdit ? <><EditIcon /> Update KYC</> : <><PlusIcon /> Create KYC</>)}
          </button>
        </div>
      </div>
    </div>
  );
};

const GSTResponseDetail = ({ gstResponse }) => {
  const [open, setOpen] = useState(false);
  if (!gstResponse) return null;
  const addr = gstResponse.principalAddress;
  return (
    <div style={{ marginTop: 10, border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
      <button onClick={() => setOpen(p => !p)}
        style={{ width: "100%", padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", border: "none", cursor: "pointer", fontSize: 12.5, fontWeight: 700, color: "#374151" }}>
        <span style={{ display: "flex", alignItems: "center", gap: 7 }}><InfoIcon />GST Provider Response</span>
        <span style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", display: "flex" }}><ChevronDownIcon /></span>
      </button>
      {open && (
        <div style={{ padding: "12px 14px", background: "#fff", borderTop: "1px solid #f1f5f9" }}>
          <InfoRow icon={<ShieldCheckIcon />} label="Status"     value={gstResponse.status} />
          <InfoRow icon={<FileTextIcon />}    label="Tax Type"   value={gstResponse.taxType} />
          <InfoRow icon={<BuildingIcon />}    label="Legal Name" value={gstResponse.legalName} />
          <InfoRow icon={<BuildingIcon />}    label="Trade Name" value={gstResponse.tradeName} />
          <InfoRow icon={<CalendarIcon />}    label="Registered" value={gstResponse.registrationDate} />
          <InfoRow icon={<CalendarIcon />}    label="Last Update" value={gstResponse.lastUpdateDate} />
          <InfoRow icon={<FileTextIcon />}    label="Constitution" value={gstResponse.constitutionOfBusiness} />
          {gstResponse.natureOfBusinessActivity?.length > 0 && (
            <InfoRow icon={<FileTextIcon />} label="Nature of Business"
              value={gstResponse.natureOfBusinessActivity.join(", ")} />
          )}
          {addr && (
            <InfoRow icon={<MapPinIcon />} label="Address"
              value={addr.addressLine || [addr.buildingNumber, addr.buildingName, addr.street, addr.location, addr.district].filter(Boolean).join(", ")} />
          )}
          {addr?.pincode && <InfoRow icon={<MapPinIcon />} label="Pincode" value={addr.pincode} mono />}
          {addr?.stateCode && <InfoRow icon={<MapPinIcon />} label="State" value={addr.stateCode} />}
        </div>
      )}
    </div>
  );
};

const VendorKYC = ({ vendorProfileId }) => {
  const [kyc,         setKyc]         = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [notFound,    setNotFound]    = useState(false);
  const [showForm,    setShowForm]    = useState(false);
  const [formMode,    setFormMode]    = useState("create");
  const [showDelete,  setShowDelete]  = useState(false);
  const [deleting,    setDeleting]    = useState(false);

  const fetchKYC = useCallback(async () => {
    setLoading(true);
    setNotFound(false);
    try {
      const { data } = await kycApi.get(vendorProfileId);
      if (data?.status === 404) { setNotFound(true); setKyc(null); return; }
      if (data?.status === 401) { toast.error("Session Expired", "Please log in again."); return; }
      if (data?.status === 403) { toast.error("Access Denied",   "You don't have permission to view KYC."); return; }
      setKyc(data?.data ?? data);
    } catch (err) {
      toast.error(
        err?.name === "TypeError" ? "Network Error" : "Failed to Load",
        err?.name === "TypeError" ? "Unable to reach the server." : "Unable to fetch KYC data. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }, [vendorProfileId]);

  useEffect(() => { fetchKYC(); }, [fetchKYC]);

  const handleDelete = async () => {
    setDeleting(true);
    const loadId = toast.loading("Deleting KYC…");
    try {
      if (!kyc?.id) throw new Error("KYC id is missing.");
      const { data } = await kycApi.delete(vendorProfileId, kyc.id);
      if (data?.status >= 400 && data?.status !== 404) throw new Error("Delete failed");
      toast.dismiss(loadId);
      toast.success("KYC Deleted", "KYC record has been permanently deleted.");
      setKyc(null);
      setNotFound(true);
      setShowDelete(false);
    } catch (err) {
      toast.dismiss(loadId);
      toast.error("Delete Failed", err.message || "Could not delete KYC record.");
    } finally {
      setDeleting(false);
    }
  };


  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", color: "#1e293b" }}>
      <style>{`
        @keyframes kyc-shimmer { 0%   { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        @keyframes kyc-fadeUp  { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes kyc-alIn    { from { opacity: 0; transform: translateX(24px) scale(0.97); } to { opacity: 1; transform: translateX(0) scale(1); } }
        @keyframes kyc-alOut   { from { opacity: 1; transform: translateX(0) scale(1); } to { opacity: 0; transform: translateX(28px) scale(0.95); } }
        @keyframes kyc-spin    { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .kyc-action-btn:hover { opacity: 0.88 !important; }
        * { box-sizing: border-box; }
      `}</style>

      <ToastContainer />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #6366f1, #3b82f6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: "#0f172a" }}>KYC</h2>
            <p style={{ margin: "2px 0 0", fontSize: 12.5, color: "#64748b" }}>GST &amp; PAN verification status for this vendor</p>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={fetchKYC} disabled={loading}
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#fff", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}
            onMouseEnter={e => e.currentTarget.style.background = "#f1f5f9"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
            {loading ? <LoaderIcon /> : <RefreshIcon />} Refresh
          </button>
          {!loading && notFound && (
            <button onClick={() => { setFormMode("create"); setShowForm(true); }}
              className="kyc-action-btn"
              style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              <PlusIcon /> Create KYC
            </button>
          )}
          {!loading && kyc && (
            <>
              <button onClick={() => { setFormMode("edit"); setShowForm(true); }}
                className="kyc-action-btn"
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#f59e0b", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                <EditIcon /> Edit
              </button>
              <button onClick={() => setShowDelete(true)}
                className="kyc-action-btn"
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", background: "#fee2e2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                <TrashIcon /> Delete
              </button>
            </>
          )}
        </div>
      </div>

      {loading ? (
        <KYCSkeleton />
      ) : notFound ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "56px 20px", background: "#fff", borderRadius: 12, border: "1px dashed #e2e8f0", gap: 12, textAlign: "center" }}>
          <div style={{ width: 60, height: 60, borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <div>
            <p style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700, color: "#374151" }}>No KYC Record Found</p>
            <p style={{ margin: 0, fontSize: 13.5, color: "#94a3b8" }}>This vendor doesn't have a KYC record yet. Create one to start verification.</p>
          </div>
          <button onClick={() => { setFormMode("create"); setShowForm(true); }}
            style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 7, padding: "10px 22px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            <PlusIcon /> Create KYC Record
          </button>
        </div>
      ) : kyc ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {[
              { label: "GST Status", value: <StatusBadge status={kyc.gst_status} />, bg: "#f0fdf4", border: "#bbf7d0" },
              { label: "PAN Status", value: <StatusBadge status={kyc.pan_status} />, bg: "#eff6ff", border: "#bfdbfe" },
              { label: "Last Updated", value: <span style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>{kyc.updated_at ?? "—"}</span>, bg: "#f8fafc", border: "#e2e8f0" },
              { label: "GST Locked", value: <span style={{ fontSize: 12, fontWeight: 700, padding: "2px 8px", borderRadius: 6, background: kyc.gst_locked ? "#fee2e2" : "#dcfce7", color: kyc.gst_locked ? "#dc2626" : "#16a34a" }}>{kyc.gst_locked ? "Locked" : "Unlocked"}</span>, bg: "#f8fafc", border: "#e2e8f0" },
              { label: "PAN Locked", value: <span style={{ fontSize: 12, fontWeight: 700, padding: "2px 8px", borderRadius: 6, background: kyc.pan_locked ? "#fee2e2" : "#dcfce7", color: kyc.pan_locked ? "#dc2626" : "#16a34a" }}>{kyc.pan_locked ? "Locked" : "Unlocked"}</span>, bg: "#f8fafc", border: "#e2e8f0" },
            ].map(({ label, value, bg, border }) => (
              <div key={label} style={{ padding: "10px 16px", background: bg, border: `1px solid ${border}`, borderRadius: 10, display: "flex", flexDirection: "column", gap: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</span>
                {value}
              </div>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>

            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}>
              <div style={{ padding: "12px 16px", background: "linear-gradient(135deg,#f0fdf4,#fff)", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 30, height: 30, borderRadius: 8, background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <ShieldCheckIcon />
                  </div>
                  <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>GST Verification</span>
                </div>
                <StatusBadge status={kyc.gst_status} />
              </div>
              <div style={{ padding: "12px 16px" }}>
                <InfoRow icon={<ShieldIcon />}     label="GSTIN"             value={kyc.gstin}             mono />
                <InfoRow icon={<BuildingIcon />}   label="Verified Name"     value={kyc.gst_verified_name} />
                <InfoRow icon={<MapPinIcon />}     label="City"              value={kyc.gst_city} />
                <InfoRow icon={<MapPinIcon />}     label="State"             value={kyc.gst_state || kyc.gst_response_json?.state_code} />
                <InfoRow icon={<MapPinIcon />}     label="Country"           value={kyc.gst_country} />
                <InfoRow icon={<MapPinIcon />}     label="Pincode"           value={kyc.gst_pincode} mono />
                <InfoRow icon={<CalendarIcon />}   label="Registration Date" value={kyc.gst_registration_date} />
                <InfoRow icon={<CalendarIcon />}   label="Last Updated"      value={kyc.gst_last_update_date} />
                <InfoRow icon={<FileTextIcon />}   label="Tax Type"          value={kyc.gst_tax_type} />
                <InfoRow icon={<FileTextIcon />}   label="Nature of Business"
                  value={kyc.gst_nature_of_business?.join(", ")} />
                {kyc.gst_last_error && (
                  <div style={{ marginTop: 10, padding: "8px 12px", background: "#fff1f2", borderRadius: 8, border: "1px solid #fecdd3", display: "flex", gap: 7 }}>
                    <AlertTriangleIcon />
                    <span style={{ fontSize: 12.5, color: "#e11d48" }}>{kyc.gst_last_error}</span>
                  </div>
                )}
                <div style={{ marginTop: 8, display: "flex", gap: 6 }}>
                  {/* <span style={{ fontSize: 11.5, color: "#64748b", padding: "2px 8px", background: "#f1f5f9", borderRadius: 6, fontWeight: 600 }}>
                    Attempts: {kyc.gst_attempts ?? 0}
                  </span> */}
                  {/* {kyc.gst_provider && (
                    <span style={{ fontSize: 11.5, color: "#64748b", padding: "2px 8px", background: "#f1f5f9", borderRadius: 6, fontWeight: 500 }}>
                      via {kyc.gst_provider}
                    </span>
                  )} */}
                </div>
                <GSTResponseDetail gstResponse={kyc.gst_response} />
              </div>
            </div>

            {/* PAN Card */}
            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}>
              <div style={{ padding: "12px 16px", background: "linear-gradient(135deg,#eff6ff,#fff)", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 30, height: 30, borderRadius: 8, background: "#dbeafe", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FileTextIcon />
                  </div>
                  <span style={{ fontSize: 13.5, fontWeight: 700, color: "#0f172a" }}>PAN Verification</span>
                </div>
                <StatusBadge status={kyc.pan_status} />
              </div>
              <div style={{ padding: "12px 16px" }}>
                <InfoRow icon={<FileTextIcon />} label="PAN"              value={kyc.pan}              mono />
                <InfoRow icon={<BuildingIcon />} label="Verified Name"    value={kyc.pan_verified_name} />
                <InfoRow icon={<BuildingIcon />} label="Registered Name"  value={kyc.pan_registered_name} />
                <InfoRow icon={<BuildingIcon />} label="Name on PAN Card" value={kyc.pan_name_pan_card} />
                <InfoRow icon={<FileTextIcon />} label="PAN Type"         value={kyc.pan_type} />
                <InfoRow icon={<FileTextIcon />} label="Reference ID"     value={kyc.pan_reference_id} mono />
                {kyc.pan_status_text && (
                  <InfoRow icon={<InfoIcon />} label="Status Text" value={kyc.pan_status_text} />
                )}
                {kyc.pan_is_valid !== null && (
                  <InfoRow icon={<ShieldCheckIcon />} label="PAN Valid"
                    badge={<span style={{ fontSize: 12, fontWeight: 700, padding: "2px 8px", borderRadius: 6, background: kyc.pan_is_valid ? "#dcfce7" : "#fee2e2", color: kyc.pan_is_valid ? "#16a34a" : "#dc2626" }}>{kyc.pan_is_valid ? "Valid" : "Invalid"}</span>} />
                )}
                {kyc.pan_aadhaar_seeding_status && (
                  <InfoRow icon={<ShieldIcon />} label="Aadhaar Seeding" value={kyc.pan_aadhaar_seeding_status_desc || kyc.pan_aadhaar_seeding_status} />
                )}
                {(kyc.pan_name_match_score !== null || kyc.pan_name_match_result) && (
                  <>
                    <InfoRow icon={<InfoIcon />} label="Name Match Score"  value={kyc.pan_name_match_score} />
                    <InfoRow icon={<InfoIcon />} label="Name Match Result" value={kyc.pan_name_match_result} />
                  </>
                )}
                {kyc.pan_last_error && (
                  <div style={{ marginTop: 10, padding: "8px 12px", background: "#fff1f2", borderRadius: 8, border: "1px solid #fecdd3", display: "flex", gap: 7 }}>
                    <AlertTriangleIcon />
                    <span style={{ fontSize: 12.5, color: "#e11d48" }}>{kyc.pan_last_error}</span>
                  </div>
                )}
                <div style={{ marginTop: 8, display: "flex", gap: 6 }}>
                  {/* <span style={{ fontSize: 11.5, color: "#64748b", padding: "2px 8px", background: "#f1f5f9", borderRadius: 6, fontWeight: 600 }}>
                    Attempts: {kyc.pan_attempts ?? 0}
                  </span> */}
                  {/* {kyc.pan_provider && (
                    <span style={{ fontSize: 11.5, color: "#64748b", padding: "2px 8px", background: "#f1f5f9", borderRadius: 6, fontWeight: 500 }}>
                      via {kyc.pan_provider}
                    </span>
                  )} */}
                </div>
              </div>
            </div>
          </div>

          {kyc.gst_response_json && (
            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" }}>
              <SectionTitle icon={<FileTextIcon />} title="GST Parsed Summary" subtitle="From gst_response_json" />
              <div style={{ padding: "0 0 12px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px,1fr))", gap: 8, padding: "0 16px" }}>
                  {[
                    { label: "Legal Name",   value: kyc.gst_response_json.legal_name },
                    { label: "Trade Name",   value: kyc.gst_response_json.trade_name },
                    { label: "GSTIN",        value: kyc.gst_response_json.gstin,       mono: true },
                    { label: "PAN",          value: kyc.gst_response_json.pan,         mono: true },
                    { label: "Tax Type",     value: kyc.gst_response_json.tax_type },
                    { label: "City",         value: kyc.gst_response_json.city },
                    { label: "State",        value: kyc.gst_response_json.state_code },
                    { label: "Pincode",      value: kyc.gst_response_json.pincode,     mono: true },
                    { label: "Reg. Date",    value: kyc.gst_response_json.registration_date },
                    { label: "Last Updated", value: kyc.gst_response_json.last_update_date },
                    { label: "Constitution", value: kyc.gst_response_json.constitution_of_business },
                  ].filter(f => f.value).map(({ label, value, mono }) => (
                    <div key={label} style={{ padding: "8px 12px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                      <div style={{ fontSize: 11, color: "#94a3b8", fontWeight: 600, marginBottom: 3, textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</div>
                      <div style={{ fontSize: 12.5, fontWeight: 700, color: mono ? "#1e40af" : "#1e293b", fontFamily: mono ? "monospace" : "inherit" }}>{value}</div>
                    </div>
                  ))}
                </div>
                {kyc.gst_response_json.address && (
                  <div style={{ margin: "10px 16px 0", padding: "10px 14px", background: "#f0f9ff", borderRadius: 8, border: "1px solid #bae6fd" }}>
                    <div style={{ fontSize: 11, color: "#0369a1", fontWeight: 700, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Registered Address</div>
                    <div style={{ fontSize: 13, color: "#0c4a6e", lineHeight: 1.55 }}>{kyc.gst_response_json.address}</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      ) : null}

      {showForm && (
        <KYCFormModal
          mode={formMode}
          initialData={formMode === "edit" ? kyc : null}
          vendorProfileId={vendorProfileId}
          onClose={() => setShowForm(false)}
          onSuccess={(updated) => { setKyc(updated); setNotFound(false); }}
        />
      )}

      {showDelete && (
        <ConfirmDeleteModal
          loading={deleting}
          onConfirm={handleDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default VendorKYC;
